import React, { Component } from "react";
import SwalServices from "../../../services/swalServices/SwalServices";
import AnnouncementServices from "../../../services/axiosServices/apiServices/AnnouncementServices.js"
import moment from "moment";
import ImageCropperWithUpload from "../../../components/ImageUpload/UploadImage";
import ValidationText from "../../../utils/validation/ValidationText";
import CommonServices from "../../../services/axiosServices/apiServices/CommonServices";
import CKClassicEditor from "../../../components/ckEditor/CKClassicEditor";
import { checkParameters, decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm,validate } from "../../../utils/validation/CommonValidator";

export default class AddEditAnnouncements extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.AnnouncementServices = new AnnouncementServices();

    this.swalServices = new SwalServices();
    this.state = {
      announcementDetails: {
        announcementDetailsId: 0,
        announcementTitle: "",
        announcementImage : "",
        redirectionLink : "",
        orderingPosition : 0,
        description: "",
        startDate: "",
        endDate: "",
        status : 0,
      },
      validationRule: {
        announcementTitle: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Title'),
          },
        ],
        description: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'description')
          }
        ],
      },
      validState: {
        isValid: true,
        error: {}
      },
      

      isLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  isValidateAllFields = () => {
    const newValidState = isValidForm(this.state.announcementDetails, this.state.validationRule, this.state.validState);
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  }
  setAnnouncementDescription = (data) => {
    if (typeof data === 'string') {
      let detail = this.state.announcementDetails;
      // var re = new RegExp('<a href="([^"]+)"', "g");
      // var result = data.replace(
      //   re,
      //   '<a href=\'$1\' target="_blank" rel="noopener noreferrer"'
      // );
      detail["description"] = data;
      this.setState({ announcementDetails: { ...detail } });
    }
  };
  validateField = (key) => {
    const newValidState = validate(
        key,
        this.state.announcementDetails,
        this.state.validationRule,
        this.state.validState
    );
    this.setState({ validState: newValidState });
};

  addEditAnnouncementDetail = () => {

    let request = {
      announcementDetailsId:
        this.state.announcementDetails.announcementDetailsId === undefined
          ? 0
          : this.state.announcementDetails.announcementDetailsId,
      announcementTitle: this.state.announcementDetails.announcementTitle,
      description: this.state.announcementDetails.description,
      redirectionLink: this.state.announcementDetails.redirectionLink === null ? "" : this.state.announcementDetails.redirectionLink,
      announcementImage: this.state.announcementDetails.announcementImage,
      orderingPosition: this.state.announcementDetails.orderingPosition,
      status: this.state.announcementDetails.status === "Active" ? 1 :  0,
    };

    this.AnnouncementServices.addEditAnnouncementDetail(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent.hasError === false) {
            this.swalServices.Success(response.message);
            this.setState({ redirect: "/Announcements" });
          } else {
            this.swalServices.Error(response.responseItem.responseContent.errorMessage);
          }
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  getAnnouncementDetailbyId = (announcementDetailsId) => {
    this.AnnouncementServices.GetAnnouncementDetailById(announcementDetailsId).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.responseItem.responseContent != null) {
          this.setState({
            announcementDetails: response.responseItem.responseContent,
          });
        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  handleChange(event) {
    let value, name;
    if (typeof event === 'string') {
      value = event;
      name = 'description';
    } else if (event.target) {
      value = event.target.value;
      name = event.target.name;
    } else {
      return;
    }

    let detail = this.state.announcementDetails;
    detail[name] = value;
    this.setState({ announcementDetails: { ...detail } });
  }

  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    let announcementDetailsId = params.get("");
    if (announcementDetailsId && (announcementDetailsId = checkParameters(announcementDetailsId, "Number"))) {
      if (announcementDetailsId != null && announcementDetailsId > 0) {
        this.getAnnouncementDetailbyId(announcementDetailsId);
      }
    }
  }

  back = () => {
    this.setState({ redirect: "/Announcements" });
  }

  saveMainImage = (file, keyId, imageIdentity) => {
    file.storagePath = "AnnouncementImage";
    this.commonServices.storeBase64Image(file).then((response) => {
      if (response != null) {
        this.swalServices.Success("Annoucement Image uploaded");
        if (file.storagePath === "AnnouncementImage") {
          let detail = this.state.announcementDetails;
          detail["announcementImage"] = response.fileName;
          this.setState({ announcementDetails: { ...detail } });
        }
      }
      else {
        this.swalServices.Error(response.message);
      }
    })
  }
  
  addNew = () => {

    let detail = this.state.announcementDetails;
    if (this.isValidateAllFields()) {
      this.setState({ announcementDetails: { ...detail } });
      this.addEditAnnouncementDetail();
    }
  }
  render() {
    if (this.state.redirect != null) {
      return <Navigate to={this.state.redirect} />;
    }
    return (
      <div className="main-body-section">
        <div className="bg-white">
          <div className="heading-part px-7 py-4 border-b flex items-center justify-between">
            <h4 className="small-title font-bold theme-color">
              Published Announcement Information
            </h4>
            {/* <button className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white">
              Save
            </button> */}
          </div>
          <div className="px-7 py-4 pt-10">
            <div className="mb-16">
              <div className="grid grid-cols-12 gap-6">
                <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 mb-2 input-sec-texts">
                      <div className="filter-types">
                        <label
                          className="filter-lable block font-medium mb-3 theme-color min-h-30"
                          htmlFor="title"
                        >
                          Title <span className="text-[#C00000]">*</span>
                        </label>
                        <input
                          id="announcementTitle"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg"
                          name="announcementTitle"
                          type="text"
                          onChange={(e) => this.handleChange(e)}
                          value={this.state.announcementDetails.announcementTitle}
                        />
                        <div>
                          <ValidationText
                            error={this.state.validState.error.announcementTitle}
                          />
                        </div>
                      </div>

                    </div>
                    <div className="col-span-12 mb-2 input-sec-texts" style={{ paddingLeft: 0, paddingRight: 40 }}>
                      <div className="filter-types">
                        <label
                          className="filter-lable block font-medium mb-3 theme-color min-h-30"
                          htmlFor="description"
                        >
                          Description <span className="text-[#C00000]">*</span>
                        </label>
                        <div className="ck-editor-sec">
                          {/* <CKClassicEditor
                            key={"description"}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              this.handleChange(data);
                            }}
                            data={this.state.announcementDetails.description}
                            onBlur={(event, editor) => {
                              this.validateField("description");
                            }}
                          /> */}
                        <CKClassicEditor
                    key={"fullPageCKEditor"}
                    onChange={(data) => {
                      this.setAnnouncementDescription(data);
                    }}
                    data={this.state.announcementDetails.description}
                    onBlur={(event, editor) => {
                      this.validateField("description");
                    }}
                  />
                          <div>
                            <ValidationText
                              error={this.state.validState.error.description}
                            />
                          </div>
                          <div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12 mb-2 input-sec-texts">
                      <div className="filter-types">
                        <label
                          className="filter-lable block font-medium mb-3 theme-color min-h-30"
                          htmlFor="redirectionLink"
                        >
                          Redirection Link
                        </label>
                        <input
                          id="redirectionLink"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg"
                          name="redirectionLink"
                          type="text"
                          onChange={(e) => this.handleChange(e)}
                          value={
                            this.state.announcementDetails.redirectionLink
                          }
                        />
                      </div>
                    </div>
                    {
                      this.state.announcementDetails.announcementDetailsId ? (
                        <div className="col-span-12 mb-2 input-sec-texts" style={{ paddingLeft: 0, paddingRight: 40 }}>
                        <div className="filter-types">
                          <label
                            className="filter-lable block font-medium mb-3 theme-color min-h-30"
                            htmlFor="orderingPosition"
                          >
                            Ordering Position <span className="text-[#C00000]">*</span>
                          </label>
                         <input
                            id="orderingPosition"
                            className="form-input rounded-none w-full shadow-red py-3 text-lg"
                            name="orderingPosition"
                            type="number"
                            onChange={(e) => this.handleChange(e)}
                            value={
                              this.state.announcementDetails.orderingPosition
                            }
                          />
                        </div>
                      </div>
                      ): null
                    }
                   
                  </div>
                </div>

                <div className="xl:col-span-6 lg:col-span-6 col-span-12 mt-10 ">
                  <div className="filter-types">
                    <ImageCropperWithUpload
                      key="Main"
                      height={285}
                      width={815}
                      isCheckValidation={true}
                      MaxFileSize={2097152}
                      MaxFileSizeMessage={"2MB"}
                      onSaveImage={this.saveMainImage}
                      imageIdentity="announcementImage"
                      intitImage={this.state.announcementDetails.announcementImage}
                      aspactRatio={815 / 285}
                      uploadBtn={"Upload Announcement Image"}
                      dimensionText={
                        "(Dimension: 815px by 285px Maximum Size: 2MB)"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-between space-x-10 mt-12">
          <div>
            <button className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white" onClick={() => this.back()}>
              Back
            </button>
          </div>
          <div>
            <button
              className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white"
              onClick={() => this.addNew()}
            >
              Publish
            </button>
          </div>
        </div>
      </div>
    );
  }
}
